import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';
import type { IconSummary } from 'shared/src/api';

/** 숏컷 아이콘 클릭 시 CLICK_SHORTCUT 발화. (전체메뉴/카테고리 화면 공용) */
export const useLogClickShortcut = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    (icon: IconSummary) => {
      logAnalyticsEvent({
        name: 'CLICK_SHORTCUT',
        analytics: icon.logging.analytics,
      });
    },
    [logAnalyticsEvent],
  );
};
